import type { Temperature } from '../services/revenueTypes';

/** "R$ 12.500" (sem centavos quando inteiro); outra moeda com o próprio símbolo; sem moeda, só o número. */
export function formatMoney(value: number | null | undefined, currency?: string | null): string {
  if (value == null || !Number.isFinite(value)) return 'A definir';
  const code = currency === 'USD' || currency === 'EUR' || currency === 'BRL' ? currency : null;
  const cents = Math.round(value * 100) % 100 !== 0;
  try {
    return code
      ? new Intl.NumberFormat(code === 'BRL' ? 'pt-BR' : 'en-US', {
          style: 'currency',
          currency: code,
          minimumFractionDigits: cents ? 2 : 0,
          maximumFractionDigits: cents ? 2 : 0,
        }).format(value)
      : new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(value);
  } catch {
    return String(value);
  }
}

export const formatBrl = (value: number | null | undefined) => formatMoney(value ?? 0, 'BRL');

/** Peso como a tela mostra: 0,6. */
export const formatWeight = (w: number) => w.toLocaleString('pt-BR', { maximumFractionDigits: 2 });

export const daysLabel = (days: number) => (days === 1 ? '1 dia' : `${days} dias`);

export const TEMPERATURE_HINT: Record<Temperature, string> = {
  quente: 'Cliente mostrou intenção concreta e atual de comprar',
  morna: 'Interesse real, sem decisão próxima',
  fria: 'Sem interesse atual ou sem resposta',
};

/** Variação "+12%" / "−5%"; null quando não há base de comparação. */
export function formatDelta(pct: number | null | undefined): string | null {
  if (pct == null || !Number.isFinite(pct)) return null;
  const rounded = Math.round(pct);
  if (rounded === 0) return '0%';
  return `${rounded > 0 ? '+' : '−'}${Math.abs(rounded)}%`;
}

/**
 * Número digitado no campo de valor, no jeito brasileiro: "12.500", "12.500,50", "12500,5" ou "12500.50".
 * Devolve NaN quando não é número.
 */
export function parseMoneyInput(raw: string): number {
  const t = raw.trim().replace(/^R\$\s*/i, '').replace(/\s/g, '');
  if (!t) return NaN;
  if (t.includes(',')) return Number(t.replace(/\./g, '').replace(',', '.'));
  if (/^\d{1,3}(\.\d{3})+$/.test(t)) return Number(t.replace(/\./g, ''));
  return Number(t);
}
